import { Diamond, X } from 'lucide-react';

interface DiamondShopProps {
  balance: number;
  onClose: () => void;
  onPurchase: (diamonds: number, label: string) => void;
}

const packages = [
  { diamonds: 20, price: '€1.99', label: 'Starter' },
  { diamonds: 60, price: '€4.99', label: 'Popular', bonus: '+10 bonus' },
  { diamonds: 150, price: '€9.99', label: 'Best value', bonus: '+35 bonus' }
];

export function DiamondShop({ balance, onClose, onPurchase }: DiamondShopProps) {
  return (
    <div className="modal-backdrop" onMouseDown={onClose}>
      <section className="modal-card shop-modal" role="dialog" aria-modal="true" aria-label="Diamond shop" onMouseDown={(event) => event.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label="Close diamond shop"><X /></button>
        <span className="eyebrow">Prototype store</span>
        <h2>Get diamonds</h2>
        <p className="modal-lead">Current balance: <strong><Diamond size={17} /> {balance}</strong></p>
        <div className="diamond-packages">
          {packages.map((item) => (
            <button className="diamond-package" key={item.diamonds} onClick={() => onPurchase(item.diamonds, item.label)}>
              <span className="package-icon"><Diamond fill="currentColor" /></span>
              <strong>{item.diamonds} diamonds</strong>
              <span>{item.price}</span>
              <small>{item.bonus ?? item.label}</small>
            </button>
          ))}
        </div>
        <p className="prototype-note">No payment is processed. Selecting a package credits the local demo wallet immediately.</p>
      </section>
    </div>
  );
}
